export default "__VITE_ASSET__q3B1sIUA__"